import React from 'react'

import PropertyList from "../components/PropertyList/PropertyList"

const PropertyListPage = () => {
  return (
    <>
      <PropertyList />

    </>
  )
}

export default PropertyListPage